import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { QuestList } from '../../components/quest-list/quest-list';

import DesktopLayout from 'shared/components/layout/desktop-layout';
import { ConnectWallet } from 'shared/components/sections/connect-wallet/connect-wallet';
import PrimaryButton from 'shared/components/ui/PrimaryButton/PrimaryButton';
import { InfiniteMaxProgressBar } from 'shared/components/ui/progress-bar/progress-bar';
import { ROUTES } from 'shared/constants';
import { useAccount } from 'shared/hooks/use-web3';
import { useQuestsStore } from 'shared/store/questsStore';
import { useUIStore } from 'shared/store/uiStore';

export const DesktopView: FC = () => {
  const { t } = useTranslation();
  const { address, isConnected } = useAccount();
  const { items, loading, error, claim, totals, refetch } = useQuestsStore();
  const { connectWalletModal } = useUIStore();
  const navigate = useNavigate();

  useEffect(() => {
    refetch();
  }, []);

  if (connectWalletModal.show && !isConnected) {
    return (
      <ConnectWallet title={'common.connectWallet'} description={'pages.dailyQuests.connectDesc'} />
    );
  }

  return (
    <DesktopLayout title={t('pages.dailyQuests.title')} isGuestMode={!address}>
      <div className="relative mx-auto flex h-full w-full max-w-screen-xs flex-col pb-12">
        <div className="py-5">
          <InfiniteMaxProgressBar
            value={Number(totals.bonusPoints ?? 0)}
            className="mb-6"
            showAttention
          />

          {error && !loading && (
            <div className="mb-4 rounded-lg border border-red/40 bg-red/20 px-4 py-3 text-center text-red">
              {error}
            </div>
          )}

          {loading ? (
            <>
              {Array.from({ length: 4 }, (_, index) => (
                <div
                  key={index}
                  className="relative flex h-40 w-full animate-pulse items-center justify-between gap-6 bg-gray/30 py-4 sm:mb-6 sm:rounded-2xl sm:border sm:border-border sm:p-5"
                />
              ))}
            </>
          ) : (
            <QuestList
              items={items}
              onClaim={claim}
              pendingTx={totals.txPending}
              loading={loading}
              onRetry={refetch}
            />
          )}
        </div>

        <div className="flex h-full w-full flex-col items-center justify-between gap-1">
          <PrimaryButton
            text="pages.dailyQuests.play"
            disabled={false}
            onClick={() => navigate(ROUTES.LOBBY)}
            className="w-full"
            isAnimated
          />
        </div>
      </div>
    </DesktopLayout>
  );
};
